// Third-party
import React from 'react';
import classNames from 'classnames';

// Utils
import { PILL_COLORS } from '../../../utils/colors';
import { Tooltip } from '../tooltips';

type Props = {
  className?: string;
  color?: PILL_COLORS;
  customElements?: JSX.Element[];
  'data-testid'?: string;
  icon?: string;
  text: string;
  withTooltip?: boolean;
};

const PillLabel = ({ className, color, customElements, 'data-testid': dataTestId, icon, text, withTooltip }: Props) => {
  let textEl = <span data-testid={dataTestId}>{text}</span>;

  if (withTooltip) {
    textEl = (
      <Tooltip className="pill-label-tooltip" message={text}>
        {textEl}
      </Tooltip>
    );
  }

  return (
    <div className={classNames('pill-label', className, color)}>
      {icon && <i className={`icon-${icon}`} />}
      {textEl}
      {customElements}
    </div>
  );
};

export default PillLabel;
